import { render, staticRenderFns } from "./TabDraft.vue?vue&type=template&id=29e914c2"
import script from "./TabDraft.vue?vue&type=script&lang=js"
export * from "./TabDraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports